import React from "react";
import "./distant-page.css";
import { Sidebar } from "../components/Sidebar";
import { MobilePannel } from "../components/MobilePannel";

const schedule = [
  {
    day: "Понеділок | 22 вересня",
    lessons: [
      { name: "Хімія", type: "інформація відсутня", emoji: "Chemistry" },
      { name: "Хімія", type: "інформація відсутня", emoji: "Chemistry" },
      { name: "Мистецтво", type: "інформація відсутня", emoji: "Art" },
      { name: "Мистецтво", type: "інформація відсутня", emoji: "Art" },
      { name: "Географія", type: "інформація відсутня", emoji: "Geography" },
      { name: "Географія", type: "інформація відсутня", emoji: "Geography" },
      { name: "Фізична культура", type: "інформація відсутня", emoji: "PE" },
    ],
  },
  {
    day: "Вівторок | 23 вересня",
    lessons: [
      { name: "Українська мова", type: "Інформація відсутня", emoji: "UaLang" },
      { name: "Українська література", type: "Інформація відсутня", emoji: "UaLiterature" },
      { name: "Алгебра", type: "Інформація відсутня", emoji: "Algebra" },
      {name: "Англійська мова",
        groups: [
            { name: "Англійська мова (1 група)", type: "інформація відсутня", emoji: "EngLang" },
            { name: "Англійська мова (2 група)", type: "інформація відсутня", emoji: "EngLang" },
        ],
      },
      { name: "Фізична культура", type: "Інформація відсутня", emoji: "PE" },
      { name: "Фізика", type: "Інформація відсутня", emoji: "Physics" },
      {name: "Інформатика",
        groups: [
            { name: "Інформатика (1 група)", type: "інформація відсутня", emoji: "IT" },
            { name: "Інформатика (2 група)", type: "інформація відсутня", emoji: "IT" },
        ],
      },
    ],
  },
  {
    day: "Середа | 24 вересня",
    lessons: [
      {name: "Англійська мова",
        groups: [
            { name: "Англійська мова (1 група)", type: "інформація відсутня", emoji: "EngLang" },
            { name: "Англійська мова (2 група)", type: "інформація відсутня", emoji: "EngLang" },
        ],
      },
      { name: "Громадянська освіта", type: "інформація відсутня", emoji: "CE" },
      { name: "Зарубіжна література", type: "інформація відсутня", emoji: "WorldLiterature" },
      { name: "Історія України", type: "інформація відсутня", emoji: "UaHistory" },
      { name: "Біологія", type: "інформація відсутня", emoji: "Biology" },
      { name: "Українська мова", type: "інформація відсутня", emoji: "UaLang" },
      { name: "Українська мова", type: "інформація відсутня", emoji: "UaLang" },
    ],
  },
  {
    day: "Четвер | 25 вересня",
    lessons: [
      { name: "Фізична культура", type: "інформація відсутня", emoji: "PE" },
      { name: "Українська література", type: "інформація відсутня", emoji: "UaLiterature" },
      { name: "Геометрія", type: "інформація відсутня", emoji: "Geometry" },
      {name: "Інформатика",
        groups: [
            { name: "Інформатика (1 група)", type: "інформація відсутня", emoji: "IT" },
            { name: "Інформатика (2 група)", type: "інформація відсутня", emoji: "IT" },
        ],
      },
      { name: "Історія України", type: "інформація відсутня", emoji: "UaHistory" },
      { name: "Алгебра", type: "інформація відсутня", emoji: "Algebra" },
      { name: "Всесвітня історія", type: "інформація відсутня", emoji: "WorldHistory" },
    ],
  },
  {
    day: "П'ятниця | 26 вересня",
    lessons: [
      { name: "Біологія", type: "інформація відсутня", emoji: "Biology" },
      { name: "Геометрія", type: "інформація відсутня", emoji: "Geometry" },
      {name: "Англійська мова",
        groups: [
            { name: "Англійська мова (1 група)", type: "інформація відсутня", emoji: "EngLang" },
            { name: "Англійська мова (2 група)", type: "інформація відсутня", emoji: "EngLang" },
        ],
      },
      { name: "Українська мова", type: "інформація відсутня", emoji: "UaLang" },
      { name: "Фізика", type: "інформація відсутня", emoji: "Physics" },
      { name: "Фізика", type: "інформація відсутня", emoji: "Physics" },
      { name: "Громадянська освіта", type: "інформація відсутня", emoji: "CE" },
    ],
  },
];

function DistantPage() {
  return (
    <section className="screen">
      <div className="sidebar-box"><Sidebar /></div>
      <section className="content">
        <h1 className="distant-page-header">розклад режимів навчання</h1>
        <h3 className="distant-page-subheader">
          На період навчання з 22.09.2025 по 26.09.2025
        </h3>

        {schedule.map((dayItem, dayIndex) => (
          <div key={dayIndex} className={`distant-page-box${dayIndex + 1}`}>
            <h2 className={`distant-page-box${dayIndex + 1}-name`}>
              {dayItem.day}
            </h2>

            {dayItem.lessons.map((lesson, lessonIndex) => (
              <div key={lessonIndex} className={`distant-page-box${dayIndex + 1}-sub${lessonIndex + 1}`}>
                {lesson.groups ? (
                  // Якщо урок має групи
                  lesson.groups.map((group, groupIndex) => (
                    <div key={groupIndex} className={`distant-page-box${dayIndex + 1}-sub${lessonIndex + 1}-group${groupIndex + 1}`}>
                      {group.emoji && (
                        <img src={`/emoji/${group.emoji}.png`} className={`distant-page-box${dayIndex + 1}-sub${lessonIndex + 1}-group${groupIndex + 1}-img`} alt={group.name}/>
                      )}
                      <p className={`distant-page-box${dayIndex + 1}-sub${lessonIndex + 1}-group${groupIndex + 1}-name`}>
                        {lessonIndex + 1}. {group.name}:
                      </p>
                      <p className={`distant-page-box${dayIndex + 1}-sub${lessonIndex + 1}-group${groupIndex + 1}-type`}>
                        {group.type}
                      </p>
                    </div>
                  ))
                ) : (
                  // Якщо урок звичайний
                  <>
                    {lesson.emoji && (
                      <img src={`/emoji/${lesson.emoji}.png`} className={`distant-page-box${dayIndex + 1}-sub${lessonIndex + 1}-img`} alt={lesson.name}/>
                    )}
                    <p className={`distant-page-box${dayIndex + 1}-sub${lessonIndex + 1}-name`}>
                      {lessonIndex + 1}. {lesson.name}:
                    </p>
                    <p className={`distant-page-box${dayIndex + 1}-sub${lessonIndex + 1}-type`}>
                      {lesson.type}
                    </p>
                  </>
                )}
              </div>
            ))}
          </div>
        ))}
      </section>
      <div className="mobile-pannel"><MobilePannel/></div>
    </section>
  );
}

export default DistantPage;
